<script lang="ts">
    import { RuleEngine } from "../RuleEngine"

    export let ftpAssetsUrl: string
    export let dependsOn: OfferAssistantDependsOnRule[]
    export let label: string
    export let imageUrl: string
    export let css: string
    export let values: { [key: string]: any }
    values = values || null

    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = true

    $: if (values && dependsOn) {
        displayComponent = ruleEngine.resolve(dependsOn, values)
    }
</script>

{#if displayComponent}
    <img src="{ftpAssetsUrl}{imageUrl}" alt="{label}" class="image-input" style="{css}" />
{/if}
